/**
 * Canonical list of POI proximity radius presets in metres.
 *
 * Capped at 5000 (5km) to match the enforced cutoff on the category-wide path:
 * `media_unit_nearest_poi` materialized view only stores distances up to 5km
 * (see packages/db/src/queries/pois/get-media-units-near-poi.ts) and callers
 * MUST NOT fall back to a live query beyond that. Do not add presets above
 * 5000 here without first changing that cutoff.
 */
export const POI_RADIUS_OPTIONS_M = [250, 500, 1000, 2000, 5000] as const;

/** Format a radius value in metres to a display label, e.g. 500 -> "500m", 1000 -> "1 km" */
export function formatPoiRadiusLabel(m: number): string {
  return m < 1000 ? `${String(m)}m` : `${String(m / 1000)} km`;
}

export function encodeCategoryKey(osmKey: string, osmValue: string): string {
  return `${osmKey}::${osmValue}`;
}

export function decodeCategoryKey(key: string): [string, string] {
  const idx = key.indexOf('::');
  if (idx === -1) return ['', ''];
  return [key.slice(0, idx), key.slice(idx + 2)];
}
